// External imports
import { SVGProps } from "react";

export default function FontIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 -960 960 960"
      color="#000"
      {...props}
    >
      <path
        fill="currentColor"
        d="M560-160v-520H360v-120h520v120H680v520H560Zm-360 0v-320H80v-120h360v120H320v320H200Z"
      />
    </svg>
  );
}
